// Copyright (c) 2019 Celadon Development LLC, All rights reserved.
// Author Alexander Mikholap <alexander.mikholap@celadon.ae>
import React from 'react';

import PropTypes from 'prop-types';

import { withStyles } from '@material-ui/core/styles';
import classNames from 'classnames';
import styles from './styles';

import { InputWithRightButton } from '../../../../components';

const DiscountCode = ({
  classes,
  discountCode,
  setDiscountCode,
  discountCodeStatus,
  validateDiscountCode,
}) => {
  const discountCodeText = 'Add discount code';

  const onPress = () => {
    if (discountCode !== '') {
      validateDiscountCode();
    }
  };

  return (
    <form className={classes.form}>
      <p className={classes.discountText}>{discountCodeText}</p>
      <InputWithRightButton
        value={discountCode}
        name={'discountCode'}
        onChange={setDiscountCode}
        onPress={onPress}
      />
      { discountCodeStatus.Status !== undefined ? (
        <p
          className={classNames(
            classes.message,
            discountCodeStatus.Status ? classes.success : classes.reject
          )}
        >
          {discountCodeStatus.Message}
        </p>) : null }
    </form>
  );
};

DiscountCode.propTypes = {
  classes: PropTypes.object,
  discountCode: PropTypes.string,
  setDiscountCode: PropTypes.func,
  discountCodeStatus: PropTypes.object,
  validateDiscountCode: PropTypes.func,
};

DiscountCode.defaultProps = {
  classes: {},
  discountCode: '',
  discountCodeStatus: {},
  validateDiscountCode: () => { },
  setDiscountCode: () => { },
};

export default withStyles(styles)(DiscountCode);
